/**
 * oddit-section-customer-reviews
 * Handles scroll progress indicator sync on mobile
 */
(function () {
  var SECTION_SELECTOR = '.oddit-section-customer-reviews';
  var sectionState = new WeakMap();

  function initSection(section) {
    if (!section || sectionState.has(section)) return;

    var track = section.querySelector('.oddit-section-customer-reviews__cards');
    var progressBar = section.querySelector('.oddit-section-customer-reviews__divider-accent');

    if (!track || !progressBar) return;

    var cards = track.querySelectorAll('.oddit-section-customer-reviews__card');
    var totalCards = cards.length;
    if (totalCards === 0) return;

    function updateProgress() {
      var scrollLeft = track.scrollLeft;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        progressBar.style.transform = 'translateX(0)';
        return;
      }

      var scrollRatio = scrollLeft / maxScroll;
      var barWidthPercent = 100 / totalCards;
      var translateX = scrollRatio * (100 - barWidthPercent);

      progressBar.style.width = barWidthPercent + '%';
      progressBar.style.transform = 'translateX(' + (translateX / barWidthPercent * 100) + '%)';
    }

    track.addEventListener('scroll', updateProgress, { passive: true });

    updateProgress();

    sectionState.set(section, {
      track: track,
      updateProgress: updateProgress
    });
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.track && state.updateProgress) {
      state.track.removeEventListener('scroll', state.updateProgress);
    }
    sectionState.delete(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
